import { kmmRequest } from './kmm';
import type { Universe } from '@smart-tv/typings/content';

interface RawUniverse {
  universeId: string;
  universeTitle: string;
}

interface RawResponse {
  universes: RawUniverse[];
  specialGenre: RawUniverse[];
}

const responseMapper = (response: RawResponse, providerCollectionId: number): Universe[] => {
  return response.universes.map((universe) => ({
    id: parseInt(universe.universeId),
    title: universe.universeTitle,
    href:
      '/provideruniverse/' +
      universe.universeTitle +
      '/' +
      providerCollectionId +
      '/' +
      universe.universeId
  }));
};

export async function getProviderCollectionUniverses(
  providerCollectionId: number
): Promise<Universe[]> {
  const response = await kmmRequest('getProviderCollectionUniverses', {
    providerCollectionId
  });

  const jsonResponse = JSON.parse(response);
  return responseMapper(jsonResponse, providerCollectionId);
}

export default getProviderCollectionUniverses;
